import React, { Component } from "react";
import { Link } from "react-router-dom";

// Redux stuff
import { connect } from "react-redux";

//Styles
import styles from "./sidebar.module.css";

//Component
import NotificationBadge from "../notificationBadge/NotificationBadge";
import LinkTab from "../linkTab/LinkTab";

//Material Ui
import SearchIcon from "@material-ui/icons/Search";
import HomeIcon from "@material-ui/icons/Home";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SettingsIcon from "@material-ui/icons/Settings";
import PieChartIcon from "@material-ui/icons/PieChart";
import TimelineIcon from "@material-ui/icons/Timeline";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import MessageIcon from "@material-ui/icons/Message";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import FullscreenIcon from "@material-ui/icons/Fullscreen";

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
        };
    }

    render() {
        const { collapsed } = this.state;
        const { firstName, lastName, profileImage } =
            this.props.provider.userData;

        const toggleCollapse = () => {
            this.setState({
                collapsed: !this.state.collapsed,
            });
        };

        return (
            <div
                className={
                    collapsed
                        ? `${styles.collapsedSidebar}`
                        : ` ${styles.sidebar}`
                }
            >
                <div className={styles.heading}>
                    <div className={styles.left}>
                        <Link to="/dashboard/profile">
                            <img src={profileImage} alt="" />
                        </Link>
                        <div
                            className={`${styles.welcomeContainer} ${
                                collapsed ? styles.hidden : ""
                            }`}
                        >
                            <span className={`${styles.welcome}`}>
                                Welcome Back,
                            </span>
                            <span className={styles.name}>
                                {firstName} {lastName}
                            </span>
                        </div>
                    </div>
                    <NotificationBadge
                        collapsed={this.state.collapsed}
                        number={"12"}
                        backgroundColor={"red"}
                    />
                </div>
                <div className={styles.navigationLinksContainer}>
                    <div className={styles.top}>
                        <LinkTab
                            name="Search"
                            hamburger={false}
                            to="/dashboard/search"
                            collapsed={this.state.collapsed}
                        >
                            <SearchIcon />
                        </LinkTab>
                        <LinkTab
                            name="Profile"
                            hamburger={true}
                            to="/dashboard/profile"
                            collapsed={this.state.collapsed}
                        >
                            <HomeIcon />
                        </LinkTab>
                        <LinkTab
                            name="Project Showcase"
                            hamburger={true}
                            to="/dashboard/projectShowcase"
                            collapsed={this.state.collapsed}
                        >
                            <AssignmentIcon />
                        </LinkTab>
                        <LinkTab
                            name="Settings"
                            hamburger={true}
                            to="/dashboard/settings"
                            collapsed={this.state.collapsed}
                        >
                            <SettingsIcon />
                        </LinkTab>
                        <LinkTab
                            name="Event Feed's"
                            hamburger={true}
                            to="/dashboard/eventFeeds"
                            collapsed={this.state.collapsed}
                        >
                            <PieChartIcon />
                        </LinkTab>
                        {/* <LinkTab
                            name="Analytics"
                            hamburger={true}
                            to="/dashboard/analytics"
                            collapsed={this.state.collapsed}
                        >
                            <TimelineIcon />
                        </LinkTab>
                        <LinkTab
                            name="Notes and Resources"
                            hamburger={true}
                            to="/dashboard/notesAndResources"
                            collapsed={this.state.collapsed}
                        >
                            <FileCopyIcon />
                        </LinkTab> */}
                    </div>
                    <div className={styles.bottom}>
                        <LinkTab
                            name="Full Screen"
                            hamburger={false}
                            collapsed={this.state.collapsed}
                        >
                            <FullscreenIcon />
                        </LinkTab>
                        <LinkTab
                            name="Support"
                            hamburger={false}
                            to="/dashboard/support"
                            collapsed={this.state.collapsed}
                        >
                            <MessageIcon />
                        </LinkTab>
                        <LinkTab
                            name="Sign Out"
                            hamburger={false}
                            to="/dashboard/signout"
                            collapsed={this.state.collapsed}
                        >
                            <ExitToAppIcon />
                        </LinkTab>
                        <div className={styles.collapseButtonContainer}>
                            <button
                                className={styles.collapseButton}
                                onClick={toggleCollapse}
                            >
                                {collapsed ? (
                                    <NavigateNextIcon />
                                ) : (
                                    <NavigateBeforeIcon />
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    provider: state.provider,
});

export default connect(mapStateToProps, {})(Sidebar);
